import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

const courseraPlusEnrollmentsApi = API('/api/courseraPlusEnrollments.v1', { type: 'rest' });

// TODO (htran) switch from Q.Promise to Promise once all of enrollmentChoiceUtils is converted over
export const enrollProduct = (
  productId: string,
  courseIdToGrantMembership?: string,
  asStandalone?: boolean
): Q.Promise<Record<string, string>> => {
  const uri = new URI();
  uri.addQueryParam('action', 'enrollProduct');
  uri.addQueryParam('userId', user.get().id);
  uri.addQueryParam('productId', productId);

  if (courseIdToGrantMembership) {
    uri.addQueryParam('courseIdToGrantMembership', courseIdToGrantMembership);
  }

  if (asStandalone) {
    // LO-5359: MONETIZE-3200 backend param. When set, enroll in the course only
    // and skip creating the parent Specialization membership and its side
    // effects (welcome email, s12n in My Learning).
    uri.addQueryParam('asStandalone', asStandalone);
  }

  return Q(courseraPlusEnrollmentsApi.post(uri.toString()));
};

export const unenrollProductForUser = (
  userId: number,
  productId: string,
  isManualCourseraPlusUnenrollment?: boolean
): Promise<Record<string, string>> => {
  const uri = new URI();
  uri.addQueryParam('action', 'unenrollProduct');
  uri.addQueryParam('userId', userId);
  uri.addQueryParam('productId', productId);

  if (isManualCourseraPlusUnenrollment) {
    uri.addQueryParam('isManualCourseraPlusUnenrollment', isManualCourseraPlusUnenrollment);
  }

  return Promise.resolve(courseraPlusEnrollmentsApi.post(uri.toString()));
};

export const unenrollProduct = (
  productId: string,
  isManualCourseraPlusUnenrollment?: boolean
): Promise<Record<string, string>> => {
  return unenrollProductForUser(user.get().id, productId, isManualCourseraPlusUnenrollment);
};
